import { AggregateDescriptor, CompositeFilterDescriptor, FilterDescriptor, isCompositeFilterDescriptor } from "@progress/kendo-data-query";
// import { formatNorwegianNumber } from "utils/helper";
import { openedStatisticsGridColumnItems } from "../GridColumns";
export const footerItemsField = [
    { field: "buyerGrossValue", sum: 0.00,  },
    { field: "buyerValue", sum: 0.00,  },
    { field: "grossWeight", sum: 0.00,  },
    { field: "quantity", sum: 0.00,  },
    { field: "numberOfUnits", sum: 0.00 },
    { field: "roundWeight", sum: 0.00 },
];


const baseAggregateFields: AggregateDescriptor[] = footerItemsField.map((item) => ({ 
    field: item.field, 
    aggregate: "sum" 
}));

const priceAggregateFields: AggregateDescriptor[] = [
    { field: "buyerPrice", aggregate: "max",  },
    { field: "buyerPrice", aggregate: "min" },
    { field: "buyerPrice", aggregate: "average" },
    { field: "grossWeight", aggregate: "max",  },
    { field: "grossWeight", aggregate: "min" },
    { field: "grossWeight", aggregate: "average" }
];

const aggregatesFields: AggregateDescriptor[] = [ ...baseAggregateFields, ...priceAggregateFields ];

const isColumnFiltered = (field: string, filters: CompositeFilterDescriptor): boolean => {
    return filters.filters.some((f) => {
        if(isCompositeFilterDescriptor(f)) {
            return isColumnFiltered(field, f as CompositeFilterDescriptor);
        }
         return (f as FilterDescriptor).field === field;
    });
}

const handleFilteredItem = (
    filters: CompositeFilterDescriptor
): { field: string; values: any[] }[] => {
    const clonedFilters: CompositeFilterDescriptor = JSON.parse(JSON.stringify(filters));
    const result: { field: string; values: any[] }[] = [];

    const processFilter = (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        if (isCompositeFilterDescriptor(filter)) {
            (filter as CompositeFilterDescriptor).filters.forEach((f) => processFilter(f));
        } else {
            const singleFilter: FilterDescriptor = { ...filter } as FilterDescriptor;
            const data = openedStatisticsGridColumnItems({ ref: undefined, data: [] }).find((col) => col.field === singleFilter.field);
            if (data) {
                singleFilter.field = data.title;
            }
            if (!singleFilter.field || typeof singleFilter.field !== "string") {
                return;
            }
            const existingItem = result.find((r) => r.field === singleFilter.field);
            if (existingItem) {
                existingItem.values.push(singleFilter.value);
            } else {
                result.push({ field: singleFilter.field, values: [singleFilter.value] });
            }
        }
    };

    clonedFilters.filters.forEach((f) => processFilter(f));
    return result;
};


export {   aggregatesFields, isColumnFiltered, handleFilteredItem };



